export default __webpack_public_path__ + "static/media/fon-net.e533f2d7.png";